
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Dadartopunecabservice() {



    const cardData =
    {
        keyword: 'Dadar to Pune Cab Service',
        heading: 'Meghana Cab : Dadar to Pune Cab Service',
        headingDescription: 'Meghana Cab offers Dadar to Pune Cab Service, providing a reliable, comfortable, and timely ride from the heart of Mumbai to your destination in Pune. Whether you are commuting for work, attending an event, or planning a weekend visit, our clean and air-conditioned cabs with experienced drivers ensure a smooth and hassle-free journey. Enjoy flexible booking options, transparent fares, and 24/7 customer support. Book your Dadar to Pune Cab with Meghana Cab and travel in comfort with service you can trust.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km from Pune, this fort is a popular destination for trekking and history lovers. It was the site of the Battle of Sinhagad in 1670, and offers panoramic views of the surrounding valleys. Visitors also enjoy local food like pithla bhakri at the summit."
  },
  {
    "title": "Shaniwar Wada",
    "description": "A historical fortification built in 1732, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. The grand gateway, expansive ruins, and the evening light and sound show depicting Maratha history make it one of Pune’s most important landmarks for cultural and heritage tourism."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, the Aga Khan Palace holds deep significance in India’s freedom struggle. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi. The palace is surrounded by lush gardens and houses a museum with Gandhian artifacts and personal belongings."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum showcases over 20,000 artifacts including musical instruments, traditional utensils, sculptures, and textiles. It offers a glimpse into India’s rich artistic and cultural history, particularly from Maharashtra."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple located in the heart of the city, Pataleshwar is dedicated to Lord Shiva. It features a circular Nandi mandapa and intricately carved pillars. The temple is a peaceful heritage site amidst urban surroundings."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Situated in Koregaon Park, this globally renowned spiritual retreat attracts visitors interested in meditation, wellness, and holistic healing. The campus offers a tranquil setting with daily meditation sessions and therapy workshops."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend getaway for Pune residents, this dam provides water to the city and is surrounded by scenic views of hills and greenery. It's ideal for picnics, photography, and relaxing by the water during early mornings or evenings."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by a Japanese garden in Okayama, this beautifully landscaped public park features manicured lawns, flowing streams, and charming bridges. It's a favorite spot for family outings and peaceful strolls."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shivaji Maharaj’s father, Shahaji, this reconstructed palace commemorates the early life of Chhatrapati Shivaji Maharaj. It houses paintings, artifacts, and replicas reflecting Maratha heritage."
  },
  {
    "title": "Fergusson College Road",
    "description": "Known for its lively ambiance and youthful vibe, this road is a hub for students, with a wide variety of cafes, bookstores, fashion outlets, and street food. It reflects the cultural vibrancy and modern spirit of Pune."
  }
],

"services": [
    {
        "name": "Book Cab Dadar to Pune",
        "description": "Book a reliable cab from Dadar to Pune with Meghana Cab for a safe, punctual, and hassle-free journey. Our seamless booking process, verified drivers, and clean vehicles make your intercity travel convenient and comfortable."
    },
    {
        "name": "One Way Taxi Dadar to Pune",
        "description": "Need a one-way ride from Dadar to Pune? Meghana Cab offers affordable one-way taxi options with AC vehicles and courteous drivers. Perfect for business trips, family visits, or quick outstation journeys."
    },
    {
        "name": "Round Trip Cab from Dadar to Pune",
        "description": "Book a round-trip cab from Dadar to Pune with flexible return times. Ideal for weekend plans, corporate visits, or day tours. Enjoy peace of mind with fixed pricing and round-the-clock service support."
    },
    {
        "name": "Affordable Cab Dadar to Pune Route",
        "description": "Travel without breaking the bank with Meghana Cab’s affordable cab services on the Dadar to Pune route. Budget-friendly prices with top-notch service, including AC rides, clean cars, and no hidden charges."
    },
    {
        "name": "AC Sedan from Dadar to Pune",
        "description": "Enjoy a smooth ride in an air-conditioned sedan from Dadar to Pune. Our sedans are perfect for individuals and small families who value comfort and cost-efficiency during intercity travel."
    },
    {
        "name": "SUV Rental Dadar to Pune",
        "description": "Travel with more space and comfort in our SUV cabs from Dadar to Pune. Great for group or family trips, our SUVs come with professional drivers, ample luggage room, and extra leg space."
    },
    {
        "name": "Private Car Hire Dadar to Pune",
        "description": "Hire a private car from Dadar to Pune for a relaxed and personalized travel experience. Our chauffeur-driven cabs offer maximum privacy and convenience for any purpose—business or leisure."
    },
    {
        "name": "Mumbai Dadar to Pune Cab Booking",
        "description": "Easily book a cab online from Mumbai's Dadar area to Pune with Meghana Cab. Choose from a range of vehicles and get instant confirmation, transparent fare estimates, and timely pickups."
    },
    {
        "name": "Dadar Pickup to Pune Drop Taxi",
        "description": "Get door-to-door service with our Dadar pickup to Pune drop taxis. Whether you're headed to a hotel, home, or office in Pune, our drivers ensure a stress-free travel experience."
    },
    {
        "name": "Fast Cab Dadar to Pune",
        "description": "Running on a tight schedule? Meghana Cab offers fast cab service from Dadar to Pune with experienced drivers who know the quickest and safest routes to get you there on time."
    },
    {
        "name": "Dadar to Pune Family Cab",
        "description": "Planning a family trip from Dadar to Pune? Choose Meghana Cab’s family-friendly vehicles with enough space, comfort, and luggage capacity to make your ride enjoyable for all ages."
    },
    {
        "name": "Comfortable Dadar to Pune Taxi",
        "description": "Enjoy a comfortable ride from Dadar to Pune with Meghana Cab. Our cars are regularly cleaned and maintained for optimal passenger comfort, with AC, cushioned seats, and smooth suspension."
    },
    {
        "name": "24/7 Taxi Service Dadar to Pune",
        "description": "Travel at any hour with our 24/7 taxi service from Dadar to Pune. Late-night or early-morning trips? We've got you covered with round-the-clock bookings and support."
    },
    {
        "name": "Best Taxi Fare Dadar to Pune",
        "description": "Get the best taxi fare for your Dadar to Pune trip with Meghana Cab. Transparent billing, fixed pricing options, and value-for-money service make us the ideal choice for every traveler."
    },
    {
        "name": "Chauffeur Service Dadar to Pune",
        "description": "Experience professional chauffeur-driven service from Dadar to Pune. Our trained drivers ensure safe navigation, courteous interaction, and timely arrivals for a pleasant journey."
    }
],

"tableData": [
    ["Book Cab Dadar to Pune", "One Way Taxi Dadar to Pune"],
    ["Round Trip Cab from Dadar to Pune", "Affordable Cab Dadar to Pune Route"],
    ["AC Sedan from Dadar to Pune", "SUV Rental Dadar to Pune"],
    ["Private Car Hire Dadar to Pune", "Mumbai Dadar to Pune Cab Booking"],
    ["Dadar Pickup to Pune Drop Taxi", "Fast Cab Dadar to Pune"],
    ["Dadar to Pune Family Cab", "Comfortable Dadar to Pune Taxi"],
    ["24/7 Taxi Service Dadar to Pune", "Best Taxi Fare Dadar to Pune"],
    ["Chauffeur Service Dadar to Pune", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Dadar to Pune Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a trusted and efficient cab service from Dadar to Pune, ideal for travelers seeking comfort, punctuality, and hassle-free intercity transport. Whether you're heading home, to the office, or for a getaway, we’ve got you covered."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Equipped Cabs",
        "WhyChoosedescription": "Our fleet includes clean, air-conditioned sedans, SUVs, and premium vehicles, all regularly sanitized and serviced to provide a smooth and safe journey from Dadar to Pune."
    },
    {
        "WhyChooseheading": "Professional Drivers Who Know the Route",
        "WhyChoosedescription": "Our experienced drivers are well-acquainted with the Mumbai–Pune Expressway and inner-city roads. They ensure a fast, safe, and convenient ride while avoiding traffic-prone routes whenever possible."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Get clear, upfront pricing for your Dadar to Pune cab with no hidden charges. Our competitive rates offer value without compromising on quality and comfort."
    },
    {
        "WhyChooseheading": "Flexible Pickup from Anywhere in Dadar",
        "WhyChoosedescription": "We offer doorstep pickup from anywhere in Dadar, whether it's a residence, hotel, railway station, or office. Your convenience is our priority, and we’re always on time."
    },
    {
        "WhyChooseheading": "24/7 Cab Service for Your Schedule",
        "WhyChoosedescription": "Travel whenever you need to—our Dadar to Pune cab services operate 24/7, perfect for early morning departures, late-night arrivals, or last-minute plans."
    },
    {
        "WhyChooseheading": "One-Way and Round Trip Options Available",
        "WhyChoosedescription": "Choose between a one-way drop or a round-trip booking, depending on your travel needs. We offer flexible plans to suit individuals, families, and business travelers alike."
    },
    {
        "WhyChooseheading": "Instant Booking and Reliable Support",
        "WhyChoosedescription": "Book your cab easily via our app, website, or phone call. Our customer support is available 24/7 to assist with bookings, changes, or custom travel requests, ensuring a smooth experience end-to-end."
    }
]






































    }

const faqData = [
    {
        question: "How can I book a cab from Dadar to Pune with Meghana Cab?",
        answer: "You can book a Dadar to Pune cab by calling Meghana Cab at +91 9075462128 or via our website for quick booking."
    },
    {
        question: "What types of vehicles are available for Dadar to Pune trips?",
        answer: "We offer sedans, SUVs, and tempo travellers to accommodate your travel group and comfort."
    },
    {
        question: "Are Meghana Cab drivers experienced with Dadar to Pune routes?",
        answer: "Yes, our drivers are familiar with the best routes between Dadar and Pune for a safe and timely journey."
    },
    {
        question: "Can I book a one-way or round-trip cab from Dadar to Pune?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip services based on your needs."
    },
    {
        question: "What does the Dadar to Pune cab fare include?",
        answer: "The fare includes driver charges, fuel, and vehicle maintenance. Additional costs like tolls may apply."
    },
    {
        question: "Is Meghana Cab available 24/7 for Dadar to Pune bookings?",
        answer: "Yes, we operate round-the-clock to support your Dadar to Pune travel plans."
    },
    {
        question: "Can I book a cab for a large group from Dadar to Pune?",
        answer: "Yes, we offer tempo travellers and SUVs suitable for larger groups."
    },
    {
        question: "Are vehicles sanitized and safe for travel?",
        answer: "All our vehicles are regularly cleaned and sanitized for your safety and comfort."
    },
    {
        question: "What payment methods do you accept for Dadar to Pune cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How can I contact Meghana Cab for Dadar to Pune cab service?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Dadar to Pune cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Dadar to Pune cab service by Meghana Cab was punctual and comfortable. Highly recommended!”',
    },
    {
        name: 'Ms. Anjali Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth and hassle-free ride from Dadar to Pune with Meghana Cab. Excellent service.”',
    },
];
































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Dadar to Pune Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/dadar-to-pune-cab.jpg",
  "description": "Book Dadar to Pune cab with Meghana Cabs for a comfortable and affordable ride. 24/7 cab service with AC sedans, SUVs, and chauffeur-driven cars for one-way or round trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5732"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/dadar-to-pune-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Dadar to Pune Cab Service | One Way & Round Trip Taxi | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Dadar to Pune cab with Meghana Cabs for a comfortable and affordable ride. 24/7 cab service with AC sedans, SUVs, and chauffeur-driven cars for one-way or round trip travel." 
  />
  <meta 
    name="keywords" 
    content="Book Cab Dadar to Pune, One Way Taxi Dadar to Pune, Round Trip Cab from Dadar to Pune, Affordable Cab Dadar to Pune Route, AC Sedan from Dadar to Pune, SUV Rental Dadar to Pune, Private Car Hire Dadar to Pune, Mumbai Dadar to Pune Cab Booking, Dadar Pickup to Pune Drop Taxi, Fast Cab Dadar to Pune, Dadar to Pune Family Cab, Comfortable Dadar to Pune Taxi, 24/7 Taxi Service Dadar to Pune, Best Taxi Fare Dadar to Pune, Chauffeur Service Dadar to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Dadartopunecabservice;